import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { ValidationType } from 'enums/validationType';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { BillingInfoDtoModel } from 'models/generated/Models.BillingInfoDto';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyService } from 'services/company.service';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'edit-billing-info',
	templateUrl: './edit-billing-info.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomInputComponent, CustomSelectComponent, TranslatePipe]
})
@CredentialRequired(CredentialType.UpdateCompanyFromCvr)
export class EditBillingInfoComponent {

	@ViewChild('saveButton') saveButton!: ButtonComponent;

	_company?: CompanyModel;
	@Input()
	set company(company: CompanyModel) {
		this._company = company
		let contactsSelect: SelectListItemModel[] = [];
		company.companyContacts.forEach(companyContact => {
			contactsSelect.push(new SelectListItemModel(companyContact.contactId!, companyContact.contact?.fullName!))
		})
		this.contactsSelect = contactsSelect;
		this.setBillingObj();
	}
	get company() { return this._company! }

	billingInfo = new BillingInfoDtoModel();
	inputTypeEnum = InputType;
	validationTypeEnum = ValidationType;
	contactsSelect?: SelectListItemModel[];

	constructor(private readonly companyService: CompanyService,
		private readonly navigation: NavigationService) { }

	saveBillingInfo() {
		this.companyService.updateBillingInfo(this.billingInfo).then(_ => {
			this.navigation.closeView(this);
		})
	}

	canSave() {
		if (!this.billingInfo || !this.company) return;

		let streetAddress = (this.billingInfo.streetAddress == undefined || this.billingInfo.streetAddress?.trim() == '') ? '' : this.billingInfo.streetAddress
		let zipcode = (this.billingInfo.zipcode == undefined || this.billingInfo.zipcode?.trim() == '') ? '' : this.billingInfo.zipcode
		let city = (this.billingInfo.city == undefined || this.billingInfo.city?.trim() == '') ? '' : this.billingInfo.city

		return (streetAddress == '' && zipcode == '' && city == '') || (streetAddress != '' && zipcode != '' && city != '');
	}

	setBillingObj() {
		this.billingInfo.companyId = this.company.id;
		this.billingInfo.companyName = this.company.billingName;
		this.billingInfo.vatNumber = this.company.billingVatNumber;
		this.billingInfo.glnNumber = this.company.billingGln;
		this.billingInfo.streetAddress = this.company.billingAddress;
		this.billingInfo.zipcode = this.company.billingZipcode;
		this.billingInfo.city = this.company.billingCity;
		this.billingInfo.contactId = this.company.billingContactId;
		if (!this.billingInfo.contactId) {
			this.billingInfo.contactId = this.company.companyContacts.find(companyContact => companyContact.contactId == this.company.primaryContactId)?.contactId;
		}
	}

	selectNewContact() {
		if (!this.billingInfo) return;
		let contact = this.company.companyContacts.find(contact => contact.contactId == this.billingInfo?.contactId)?.contact;
		if (!contact) return;
		this.billingInfo.contactId = contact.id;
		this.billingInfo.contactFirstName = contact.firstName!;
		this.billingInfo.contactLastName = contact.lastName!;
	}
}
